import Temp from '@/courier/Temp'
import courierRateScg from "@/plugins/courier_rate_scg.js";

export default class SCGExpress extends Temp {

    static CODE = 'SCG';

    constructor() {
        super( SCGExpress.CODE ); 
    }

    getZone( item ){
        let type , from , to
        let cross_price = 0
        let remote_area = 0

        remote_area = super.checkRemoteArea( Number(item.toPostcode) );
        
        from = super.checkZone( item.fromPostcode )
        to = super.checkZone( item.toPostcode )
        if( from != to ){
          type = 2
        }else{
          type = 1
        } 

        return {
            rate_type : type ,
            rate_remote_area : remote_area ,
            cross_price : cross_price
        }
    }

    checkWeight( courierRates, item ){
      let res = {
        index: item.index,
        findType: null
      }
      let find_key = courierRateScg.findIndex( type => {
        return type.key == item.keySize
      })
      if( find_key < 0 )return res
      res.findType = courierRateScg[find_key].weight.find( val => {
        return item.weight <= val.max_weight
      })

      if( res.findType == undefined )return res
      res.index = courierRates.findIndex(rate => {
          return rate.dimension == res.findType.size
      })
      return res
    }

    async checkRemoteAreaByCorrectorDest( addressRemote ){
      return new Promise(resolve => {
        super.getRemoteArea( addressRemote ).then( res => {
          if( res.status === 1 && ((res.data).hasOwnProperty('isRemote') 
              || (res.data).hasOwnProperty('isRemote100') )
              && res.data.isRemote.includes('scg') 
              || ( (res.data).hasOwnProperty('isIsland') && res.data.isIsland.includes('scg') )
          ){
            resolve( true );
          }else if( res.status === 0 && res.data.length === 0 ){
            resolve( true );
          }else{
            resolve( false );
          }
        }) 
      })
    }

}